'use client'
import { Card, CardContent, CardHeader, Divider, Stack } from '@mui/material'
import { useState } from 'react'
import Typography from '@mui/material/Typography'
import { typography as typographyConfig } from '../../theme/core/typography'

export default function TypographyShowcase() {
    const [size, setSize] = useState<"small" | "medium">("small")
    return (
        <Card>
            <CardHeader title='Typography Showcase' />
            <CardContent>
                <Stack spacing={2}>
                    {Object.entries(typographyConfig)
                        .filter(([key]) => [
                            'h1',
                            'h2',
                            'h3',
                            'h4',
                            'h5',
                            'h6',
                            'subtitle1',
                            'subtitle2',
                            'body1',
                            'body2',
                            'caption',
                            'overline',
                            'button',
                        ].includes(key))
                        .map(([variant, config]) => {
                            // Helper para extraer los fontSize de breakpoints
                            const getPx = (rem) => {
                                if (!rem) return '';
                                const num = parseFloat(rem.replace('rem', ''));
                                return `${num * 16}px`;
                            };
                            const fontSizes = [];
                            if (config && typeof config === 'object') {
                                if (config.fontSize) fontSizes.push(`Base: ${getPx(config.fontSize)}`);
                                if (config['@media (min-width:600px)']?.fontSize) fontSizes.push(`sm: ${getPx(config['@media (min-width:600px)'].fontSize)}`);
                                if (config['@media (min-width:900px)']?.fontSize) fontSizes.push(`md: ${getPx(config['@media (min-width:900px)'].fontSize)}`);
                                if (config['@media (min-width:1200px)']?.fontSize) fontSizes.push(`lg: ${getPx(config['@media (min-width:1200px)'].fontSize)}`);
                            }
                            return (
                                <Stack key={variant} spacing={1}>
                                    <Typography variant="body2" sx={{ minWidth: 110, fontWeight: 700 }}>
                                        {variant}
                                    </Typography>
                                    <Typography variant={variant as any}>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: 'text.secondary', minWidth: 70 }}>
                                        {fontSizes.join(' | ')}
                                    </Typography>
                                    <Divider />
                                </Stack>
                            );
                        }
                    )}
                </Stack>
            </CardContent>
        </Card>
    )
}
